import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { useDispatch } from 'react-redux';
import { Button } from '../buttons';
import Modal from '../Modal';
import { Diary } from '../icons';
import Section from '../edu/Section';
import DiaryEntryView from './DiaryEntryView';
import DiaryEntryCreateContainer from '../../containers/DiaryEntryCreateContainer';
import './DiaryView.css';
import { lockDiary } from '../../actions/auth';
import LoadingSpinner from '../LoadingSpinner';
import ErrorMessage from '../ErrorMessage/ErrorMessage';

const DiaryView = props => {
  const dispatch = useDispatch();
  const { firstName, entries, loading, error } = props;
  // state management for entry modal
  const [createDiaryEntryOpen, setCreateDiaryEntryOpen] = useState(false);

  const openCreateDiaryEntry = () => {
    setCreateDiaryEntryOpen(true);
  };

  const closeCreateDiaryEntry = () => {
    setCreateDiaryEntryOpen(false);
  };

  // clean up component by locking diary
  useEffect(() => {
    const { handleLock } = bindActionCreators(
      {
        handleLock: lockDiary
      },
      dispatch
    );

    return () => {
      handleLock();
    };
  }, [dispatch]);

  if (loading) {
    return <LoadingSpinner size="large" colorScheme="blue" />;
  }

  if (error) {
    return <ErrorMessage />;
  }

  return (
    <div>
      <div className="page-header diary__page-header">
        <h1>{`${firstName}'s Diary`}</h1>
        <Modal
          isOpen={createDiaryEntryOpen}
          onRequestClose={closeCreateDiaryEntry}
        >
          <DiaryEntryCreateContainer
            onDiaryEntryCreated={closeCreateDiaryEntry}
          />
        </Modal>
        <Button onClick={openCreateDiaryEntry}>Add an Entry</Button>
      </div>

      <Section colorScheme="red">
        {entries.length > 0 ? (
          <div className="diary-view__container">
            {entries.map(entry => (
              <DiaryEntryView key={entry.id} entry={entry} />
            ))}
          </div>
        ) : (
          <div className="diary-view__no-entries">
            <Diary viewBox="0 0 32 32" />
            <div className="diary-view__no-entries-text">
              You do not have any entries yet. <br /> Add your first one.{' '}
            </div>
          </div>
        )}
      </Section>
    </div>
  );
};

DiaryView.propTypes = {
  firstName: PropTypes.string.isRequired,
  entries: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      content: PropTypes.string,
      feeling: PropTypes.string,
      hidden: PropTypes.bool
    })
  ),
  loading: PropTypes.bool.isRequired,
  error: PropTypes.shape({})
};

DiaryView.defaultProps = {
  entries: [],
  error: null
};

export default DiaryView;



// WEBPACK FOOTER //
// ./src/components/diary/DiaryView.js